module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He sat in his room, in a chair by the window that looked down on a pretty and peaceful street. The girls who lived in the house across the way played double-Dutch jump rope; a fat man smoking a cigar walked slowly along with his fat twin dog on a leash; boys were gathered around the stoop of a house on the corner, haggling over marbles. Saturday morning’s strong sunlight dappled through the new spring green of maples and London planes lining the block.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a sigh of expectant regret that sounded a thousand years old, he turned toward a ringing telephone on the table next to him. He stared at the flashing light of an answering machine connected to the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the machine picked up on the sixth ring, there were his recorded words: “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Father Timothy Kelly here ")]), _vm._v(" … "), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" I’m not about just now ")]), _vm._v(" … "), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Kindly leave your name and telephone number and I’ll call you back as quick as I can … Have a blessed day.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The machine clicked once to receive and record a message. There was the crackle of static. And with that sound, he knew, the taint of the past intruding on the present.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over the past two days, ten such calls had come to him. Ten "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v(" times he had not picked up the phone. Ten times, he knew who it was who refused to speak up. Yes, Lord, he knew.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But today, the caller spoke: “What is a true patriot?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father Timothy Kelly knew the voice. Yes, Lord. He placed a pale, spotted hand over his thumping chest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The voice was full of the memories of another place: the dark slow waters of the River Liffey moving under O’Connell Street footbridges; February’s wind hissing through hedges along clay roads beyond the city; his Wellingtons, mud-spattered, plodding through the dunghill behind the byre, where he and his brothers picked black-gilled mushrooms when there was nothing else for the family dinner … ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v(" … and later, before he had to leave the land of his youth, cloth hoods masking the faces of righteous comrades.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Had he not remembered this voice, and these words, so many times over the years? Had he not dreamed of them only last night?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again, the caller asked, “What is a true patriot?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was no sense anymore in ignoring this. He picked up the telephone receiver, and sighed another thousand-year-old sigh. The machine continued recording.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father Kelly replied to his past, with the words he had long ago been instructed to say in response to the question posed: “True patriots have guns in their hands and poems in their heads. Nevermore!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51d495d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter02.vue
// module id = 84
// module chunks = 0